import React from 'react';
import '../App.css';
import Nav from "../component/Nav";
import {Sticky, StickyContainer} from "react-sticky";
import OthersImage from "../component/OtherWorksImage";
export default class BgPaint extends React.Component{
    constructor() {
        super();
        this.state = {
            width: window.innerWidth,
        };
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };
    render(){
        const table={
            display:"table",
            margin:0,
            width:"100vw",}

        const emailStyle={
            fontFamily:"华文细黑",
            display:"inline",
            lineHeight:"10pt",
        }


        const { width } = this.state;
        const isMiddleScreen = width <= 1366;
        const isMobile = width <= 768;
        if (isMobile){
            return(
                <section style={{height:"auto"}}>
                    <Nav/>
                    {/*<StickyContainer>*/}
                        <OthersImage/>
                        <div style={{fontSize:"8pt",paddingTop:"6%"}}>© 2020 Brandon Lai. All rights reserved.</div>

                </section>
            );}
        if (isMiddleScreen){let navStyle3={
            minWidth:"10vw",
            listStyle:"none",
            paddingTop:"8pt",
            paddingBottom:"13pt",
            fontSize: "11pt",
            margin:0}

            let liStyle={
                color:"#4d4d4d",
                display:"inline",
                paddingInline:"5pt",
            }
            return (
                <section style={{height:"auto"}}>
                    <Nav/>
                    <StickyContainer>
                        <OthersImage/>
                        <div className={"arrow"} style={{padding:"3% 10% 3% 3%", textAlign:"right"}}>
                            <a className="animated-arrow" href="/works/Background Paint">
                    <span className="the-arrow -left">
                        <span className="shaft"></span>
                    </span>
                                <span className="main">
                        <span className="text">
                            Background Paint
                        </span>
                        <span className="the-arrow -right">
                            <span className="shaft"></span>
                        </span>
                    </span>
                            </a>
                        </div>
                        <div style={{fontSize:"8pt"}}>© 2020 Brandon Lai. All rights reserved.</div>
                        <Sticky topOffset={10}>
                            {({
                                  style,
                              }) => (
                                <header style={style}>
                                    <div style={{backgroundColor:"white",paddingTop:"15pt"}}>
                                        <div style={emailStyle}>
                                            orenjikun.art@gmail.com</div>
                                        <div style={table}>
                                            <ul style={navStyle3}>
                                                <a href={"/works/lego"}><li style={liStyle}>Background Layout</li></a>
                                                <a href={"/works/Background Paint"}>
                                                    <li style={liStyle}>Background Paint</li>
                                                </a>
                                                <a href={"/works/other_works"}><li style={liStyle}>other_works</li></a>
                                                <a href={"/works/Personal"}><li style={liStyle}>Personal</li></a>
                                                <a href={"/about"}><li style={liStyle}>about</li></a>
                                            </ul>
                                        </div>
                                    </div>
                                </header>
                            )}
                        </Sticky>
                    </StickyContainer>
                </section>);}
        else{
            let navStyle2={
                minWidth:"10vw",
                listStyle:"none",
                paddingTop:"10pt",
                paddingBottom:"13pt",
                fontSize: "15pt",
                margin:0,
            }
            const liStyle={
                color:"#4d4d4d",
                display:"inline",
                paddingInline: "1em",
            }
            const table={
                display:"table",
                margin:0,
                width:"100vw",}
            return(
                <section style={{height:"auto"}}>
                    <Nav/>
                    <StickyContainer>
                        <OthersImage/>
                        <div className={"arrow"} style={{padding:"3% 10% 3% 3%", textAlign:"right"}}>
                            <a className="animated-arrow" href="/works/background_paint">
                    <span className="the-arrow -left">
                        <span className="shaft"></span>
                    </span>
                                <span className="main">
                        <span className="text">
                            Background Paint
                        </span>
                        <span className="the-arrow -right">
                            <span className="shaft"></span>
                        </span>
                    </span>
                            </a>
                        </div>
                        <div style={{fontSize:"8pt"}}>© 2020 Brandon Lai. Website designed by Yuzu. All rights reserved.</div>
                        <Sticky topOffset={10}>
                            {({
                                  style,
                              }) => (
                                <header style={style}>
                                    <div style={{backgroundColor:"white",paddingTop:"15pt"}}>
                                        <div style={emailStyle}>
                                           orenjikun.art@gmail.com</div>
                                        <div style={table}>
                                            <ul style={navStyle2}>
                                                <a href={"/works/background_layout"}><li style={liStyle}>Background Layout</li></a>
                                                <a href={"/works/background_paint"}>
                                                    <li style={liStyle}>Background Paint</li>
                                                </a>
                                                <a href={"/works/other_works"}><li style={liStyle}>Other Works</li></a>
                                                <a href={"/works/personal"}><li style={liStyle}>Personal</li></a>
                                                <a href={"/about"}><li style={liStyle}>about</li></a>
                                            </ul>
                                        </div>
                                    </div>
                                </header>
                            )}
                        </Sticky>
                    </StickyContainer>
                </section>
            );}
    }}
